import {Component, Input, OnInit, NgModule, ViewEncapsulation, Injector} from '@angular/core';

import {StringToStringMap} from "../../../../interfaces/string-string-map.interface";
import {CacheService} from "../../../../../services/sys/cache.service";
import {StaticsService} from "../../../../../services/sys/statics.service";
import {Observable, Subscription} from "rxjs";
import {FilterManagerService} from "../../../../../services/ui/filter-manager.service";
import {QueryManagerService} from "../../../../../services/domain/query-manager.service";
import {QueryValue} from "../../../../../services/model/queryValue";
import {EfastFilterBaseComponent} from "../efast-filter-base.component";
import {FilterValue} from "../../../../../services/model/filterValue";

@Component({
    selector: 'efast-filter-defined-contribution',
    templateUrl: 'efast-filter-defined-contribution.component.html',
    styleUrls: ['efast-filter-defined-contribution.component.css'],
    standalone: false
})

export class EfastFilterDefinedContributionComponent extends EfastFilterBaseComponent implements OnInit {


    constructor(protected injector: Injector) {
        super(injector);
    }

    ngOnInit() {

        this.title= this.cacheService.getLabelFromResource('FILTER:FILTERDefinedContributionTitle');

        let filterValues: FilterValue[] = new Array();

        this.filterCategory.filterType = this.staticsService.getFilterType().DEFINED_CONTRIBUTION;

        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERDefinedContributionLbl1'),
            this.staticsService.getPlanCodeFilter().CODE_TYPE_CONTRIBUTION, false))
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERDefinedContributionLbl2'),
            this.staticsService.getPlanCodeFilter().CODE_2A));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERDefinedContributionLbl3'),
            this.staticsService.getPlanCodeFilter().CODE_2B));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERDefinedContributionLbl4'),
            this.staticsService.getPlanCodeFilter().CODE_2C));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERDefinedContributionLbl5'),
            this.staticsService.getPlanCodeFilter().CODE_2D));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERDefinedContributionLbl6'),
            this.staticsService.getPlanCodeFilter().CODE_2E));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERDefinedContributionLbl7'),
            this.staticsService.getPlanCodeFilter().CODE_2F));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERDefinedContributionLbl8'),
            this.staticsService.getPlanCodeFilter().CODE_2G));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERDefinedContributionLbl9'),
            this.staticsService.getPlanCodeFilter().CODE_2H));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERDefinedContributionLbl10'),
            this.staticsService.getPlanCodeFilter().CODE_2I));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERDefinedContributionLbl11'),
            this.staticsService.getPlanCodeFilter().CODE_2J));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERDefinedContributionLbl12'),
            this.staticsService.getPlanCodeFilter().CODE_2K));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERDefinedContributionLbl13'),
            this.staticsService.getPlanCodeFilter().CODE_2L));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERDefinedContributionLbl14'),
            this.staticsService.getPlanCodeFilter().CODE_2M));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERDefinedContributionLbl15'),
            this.staticsService.getPlanCodeFilter().CODE_2N));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERDefinedContributionLbl16'),
            this.staticsService.getPlanCodeFilter().CODE_2O));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERDefinedContributionLbl17'),
            this.staticsService.getPlanCodeFilter().CODE_2P));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERDefinedContributionLbl18'),
            this.staticsService.getPlanCodeFilter().CODE_2Q));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERDefinedContributionLbl19'),
            this.staticsService.getPlanCodeFilter().CODE_2R));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERDefinedContributionLbl20'),
            this.staticsService.getPlanCodeFilter().CODE_2S));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERDefinedContributionLbl21'),
            this.staticsService.getPlanCodeFilter().CODE_2T));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERDefinedContributionLbl22'),
            this.staticsService.getPlanCodeFilter().CODE_2U));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERDefinedContributionLbl23'),
            this.staticsService.getPlanCodeFilter().CODE_2V));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERDefinedContributionLbl24'),
            this.staticsService.getPlanCodeFilter().CODE_2W));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERDefinedContributionLbl25'),
            this.staticsService.getPlanCodeFilter().CODE_2X));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERDefinedContributionLbl26'),
            this.staticsService.getPlanCodeFilter().CODE_2Y));
        this.filterCategory.filterValues = filterValues;

        super.ngOnInit();
    }

    protected expandClick() {
        super.expandClick();
    }

    //extended
    protected searchChangeEvent() {
        this.setBucket(this.applicationService.getAfsForm().facets.plancode.buckets);
        super.searchChangeEvent();
    }

    //extended
    protected rowClick(filterValue: FilterValue) {

        super.rowClick(filterValue);

        this.queryManagerService.addQueryValueNoSearch(this.staticsService.getCategoryType().PLAN_CODE, this.queryValue, true)
    }
}